import React from 'react';
import { motion } from 'framer-motion';

const Header = ({ title }) => {
  // Animação para o título com brilho dourado
  const titleAnimation = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
    hover: {
      textShadow: [
        "0 0 5px rgba(234, 179, 8, 0.5)",
        "0 0 15px rgba(234, 179, 8, 0.8)",
        "0 0 20px rgba(234, 179, 8, 0.9)",
        "0 0 15px rgba(234, 179, 8, 0.8)",
        "0 0 5px rgba(234, 179, 8, 0.5)"
      ],
      transition: {
        duration: 1.5,
        repeat: Infinity,
        repeatType: "reverse"
      }
    }
  };

  // Animação para o logo
  const logoAnimation = {
    hidden: { scale: 0, opacity: 0 },
    visible: { 
      scale: 1, 
      opacity: 1, 
      transition: {
        type: "spring",
        damping: 15,
        stiffness: 200
      }
    },
    hover: {
      scale: 1.03,
      boxShadow: "0 0 40px rgba(234, 179, 8, 0.9)",
      transition: {
        duration: 0.3
      }
    }
  };
  
  return (
    <motion.header 
      className="pt-8 pb-6 mb-8"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center justify-center">
          {/* Container do logo com ajustes para centralização perfeita */}
          <div className="relative flex items-center justify-center w-full mb-10">
            <motion.div
              className="w-40 h-40 md:w-48 md:h-48 rounded-full flex items-center justify-center"
              initial="hidden"
              animate="visible"
              whileHover="hover"
              variants={logoAnimation}
              style={{
                boxShadow: "0 0 35px rgba(234, 179, 8, 0.7)",
                background: "#000000",
                border: "3px solid #eab308",
                padding: "2px"
              }}
            >
              <div className="relative w-full h-full flex items-center justify-center overflow-hidden rounded-full">
                <img 
                  src="/logo.png" 
                  alt="PorterHouse Carnes Logo" 
                  className="w-[92%] h-[92%] object-contain"
                  style={{ 
                    filter: "drop-shadow(0 0 8px rgba(234, 179, 8, 0.7))",
                  }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "https://via.placeholder.com/128x128?text=PorterHouse+Carnes";
                  }}
                />
              </div>
            </motion.div>
          </div>
          
          <motion.h1 
            className="text-3xl md:text-4xl font-playfair font-bold text-gold text-center tracking-wide text-contrast"
            initial="hidden"
            animate="visible"
            whileHover="hover"
            variants={titleAnimation}
            transition={{ delay: 0.3, duration: 0.5 }}
            style={{
              textShadow: "0 2px 4px rgba(0,0,0,0.9), 0 0 15px rgba(0,0,0,0.8)",
            }}
          >
            {title || "PorterHouse Carnes"}
          </motion.h1>
          
          <motion.div 
            className="h-1 w-24 bg-gold mt-3"
            initial={{ width: 0 }}
            animate={{ width: "6rem" }}
            transition={{ delay: 0.6, duration: 0.5 }}
            whileHover={{
              width: "12rem",
              transition: { duration: 0.3 }
            }}
            style={{
              boxShadow: "0 0 10px rgba(234, 179, 8, 0.7)"
            }}
          />
          
          <motion.p 
            className="mt-4 text-gold text-center max-w-md text-contrast"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8, duration: 0.5 }}
            whileHover={{
              scale: 1.05,
              textShadow: "0 0 8px rgba(234, 179, 8, 0.8), 0 0 10px rgba(0,0,0,0.9)"
            }}
            style={{
              textShadow: "0 1px 3px rgba(0,0,0,1), 0 0 10px rgba(0,0,0,0.9)",
              fontWeight: 600
            }}
          >
            Carnes selecionadas e sabor incomparável
          </motion.p>
        </div>
      </div>
    </motion.header>
  );
};

export default Header; 
